__turbopack_context__.v({
  "stickyCtaEndSpacer": "styles-module-scss-module__D1iy9W__stickyCtaEndSpacer",
});
